const activationStatus = [
  {
    label: 'Approved',
    value: 'APPROVED'
  },
  {
    label: 'Rejected',
    value: 'REJECTED'
  },
  {
    label: 'Pending Approval',
    value: 'PENDING_APPROVAL'
  },
  {
    label: 'Not Uploaded',
    value: 'NOT_UPLOADED'
  },
  {
    label: 'Not Started',
    value: 'NOT_STARTED'
  }
];

const kycStatus = [
  {
    label: 'Approved',
    value: 'APPROVED'
  },
  {
    label: 'Rejected',
    value: 'REJECTED'
  },
  {
    label: 'Pending Approval',
    value: 'PENDING_APPROVAL'
  },
  {
    label: 'KYC In-Progress',
    value: 'NOT_UPLOADED'
  },
  {
    label: 'Not Started',
    value: 'NOT_STARTED'
  }
];

const merchantStatus = [
  {
    label: 'Active',
    value: 'ACTIVE_REFERRAL'
  },
  {
    label: 'Live',
    value: 'LIVE_REFERRAL'
  },
  {
    label: 'Inactive',
    value: 'INACTIVE_REFERRAL'
  },
  {
    label: 'Pending',
    value: 'PENDING_REFERRAL'
  }
];

const leadPriority = [
  {
    label: 'Low',
    value: 'LOW'
  },
  {
    label: 'Medium',
    value: 'MEDIUM'
  },
  {
    label: 'High',
    value: 'HIGH'
  }
];

const leadStatus = [
  {
    label: 'New',
    value: 'NEW'
  },
  { label: 'Open - Not Contacted', value: 'OPEN_NOT_CONTACTED' },
  { label: 'Working', value: 'WORKING' },
  { label: 'Prospect', value: 'PROSPECT' },
  { label: 'Unqualified', value: 'UNQUALIFIED' }
];

const businessEntityType = [
  { label: 'Individual/Freelancer', value: 'INDIVIDUAL_FREELANCER' },
  {
    label: 'Society/Trust - Education',
    value: 'SOCIETY_TRUST_EDUCATION'
  },
  {
    label: 'HUF (Hindu Undivided Family)',
    value: 'HUF'
  },
  {
    label: 'Limited Liability Partnership',
    value: 'LIMITED_LIBLITY_PARTNERSHIP'
  },
  { label: 'Partnership Firm', value: 'PARTNERSHIP_FIRM' },
  { label: 'Sole Proprietor', value: 'SOLE_PROPIATOR' },
  {
    label: 'Private Ltd/Public Ltd/OPC',
    value: 'PRIVATE_LTD_PUBLIC_LTD_OPC'
  },
  { label: 'Trust/NGO - Donations', value: 'TRUST_NGO_DONATION' },
  { label: 'Government Entity', value: 'GOVERNMENT_ENTITY' },
  {
    label: 'Co-operative Credit Society/JV/AOP',
    value: 'COPERATIVE_CREDIT_SOCIETY_JV_AOP'
  }
];

const productList = [
  { label: 'NA', value: 'NA' },
  { label: 'Payment Gateway', value: 'PAYMENT_GATEWAY' },
  { label: 'Payment Link', value: 'PAYMENT_LINKS' },
  { label: 'Wire', value: 'WIRE' },
  { label: 'Instacollect', value: 'INSTACOLLECT' },
  { label: 'Bridgebuzz', value: 'BRIDGEBUZZ' },
  { label: 'Webstore', value: 'WEBSTORE' },
  { label: 'Easycollect', value: 'EASYCOLLECT' },
  { label: 'Feesbuzz', value: 'FEESBUZZ' },
  { label: 'Buildbuzz', value: 'BUILDBUZZ' },
  { label: 'Smartbilling', value: 'SMARTBILLING' },
  { label: 'Teller', value: 'TELLER' },
  { label: 'Easebuzz Capital', value: 'EASEBUZZ_CAPITAL' },
  { label: 'Partner Onboarding', value: 'PARTNER_ONBOARDING' },
  { label: 'Epos', value: 'EPOS' },
  { label: 'Submerchant', value: 'SUBMERCHANT' },
  { label: 'Partners Platform', value: 'PARTNERS_PLATFORM' },
  { label: 'Fees Collection', value: 'FEES_COLLECTION' },
  { label: 'QR Based Collections', value: 'QR_BASED_COLLECTIONS' },
  { label: 'NEFT IMPS RTGS Collection', value: 'NEFT_IMPS_RTGS_COLLECTION' },
  { label: 'Invoice Based Collections', value: 'INVOICE_BASED_COLLECTIONS' },
  { label: 'Form Based Collections', value: 'FORM_BASED_COLLECTIONS' },
  { label: 'Recurring Payment Collections', value: 'RECURRING_PAYMENT_COLLECTIONS' },
  { label: 'Payment Disbursements', value: 'PAYMENT_DISBURSEMENTS' },
  { label: 'Prepaid Cards', value: 'PREPAID_CARDS' },
  { label: 'Expense Management', value: 'EXPENSE_MANAGEMENT' },
  { label: 'Verification Services', value: 'VERIFICATION_SERVICES' },
  { label: 'Cashbacks Coupons', value: 'CASHBACKS_COUPONS' },
  { label: 'Hosting A Webstore/e Commerce Store', value: 'HOSTING_A_WEBSTORE_E_COMMERCE_STORE' },
  { label: 'Landing Based Solution', value: 'LANDING_BASED_SOLUTION' },
  { label: 'Sub Aggregator/sub Merchant Model', value: 'SUB_AGGREGATOR_SUB_MERCHANT_MODEL' }
];

const accountSegment = [
  {
    label: 'NA',
    value: 'NA'
  },
  {
    label: 'Enterprise (Monthly GTV > ₹ 25 Cr.)',
    value: 'ENTERPRISE'
  },
  {
    label: 'Mid Size Business (Monthly GTV ₹ 3 Cr. to 25 Cr.)',
    value: 'MID_SIZE_BUSINESS'
  },
  {
    label: 'Small Size Business (Monthly GTV ₹ 50 Lakhs to 3 Cr.)',
    value: 'SMALL_SIZE_BUSINESS'
  },
  {
    label: 'Micro Business (Monthly GTV < ₹ 50 Lakhs)',
    value: 'MICRO_SIZE_BUSINESS'
  },
  {
    label: 'Channel Partner',
    value: 'CHANNEL_PARTNER'
  }
];

const industry = [
  { label: 'NA', value: 'NA' },
  { label: 'Agriculture', value: 'AGRICULTURE' },
  { label: 'Apparel', value: 'APPAREL' },
  { label: 'Automotive dealers', value: 'AUTOMOTIVE_DEALERS' },
  { label: 'Automotive other services', value: 'AUTOMOTIVE_OTHER_SERVICES' },
  { label: 'Banking software services', value: 'BANKING_SOFTWARE_SERVICES' },
  { label: 'Banking', value: 'BANKING' },
  { label: 'Biotechnology', value: 'BIOTECHNOLOGY' },
  { label: 'Books and stationary', value: 'BOOKS_AND_STATIONARY' },
  { label: 'Chemical', value: 'CHEMICAL' },
  { label: 'Communications', value: 'COMMUNICATIONS' },
  { label: 'Computer equipment', value: 'COMPUTER_EQUIPMENT' },
  { label: 'Corporate card services', value: 'CORPORATE_CARD_SERVICES' },
  { label: 'Cable and internet services', value: 'CABLE_AND_INTERNET_SERVICES' },
  { label: 'Construction material', value: 'CONSTRUCTION_MATERIAL' },
  { label: 'Consulting', value: 'CONSULTING' },
  { label: 'Education', value: 'EDUCATION' },
  { label: 'Electronics and consumer durables', value: 'ELECTRONICS_AND_CONSUMER_DURABLES' },
  { label: 'Energy', value: 'ENERGY' },
  { label: 'Engineering', value: 'ENGINEERING' },
  { label: 'Entertainment', value: 'ENTERTAINMENT' },
  { label: 'Enviromental', value: 'ENVIROMENTAL' },
  { label: 'Finance', value: 'FINANCE' },
  { label: 'Food and beverage', value: 'FOOD_AND_BEVERAGE' },
  { label: 'Gaming', value: 'GAMING' },
  { label: 'General merchandise', value: 'GENERAL_MERCHANDISE' },
  { label: 'Gift and jewelers', value: 'GIFT_AND_JEWELERS' },
  { label: 'Goverment service', value: 'GOVERMENT_SERVICE' },
  { label: 'Grocery and supermarkets', value: 'GROCERY_AND_SUPERMARKETS' },
  { label: 'Hardware', value: 'HARDWARE' },
  { label: 'Home furnishing', value: 'HOME_FURNISHING' },
  { label: 'Hotel catering restaurants', value: 'HOTEL_CATERING_RESTAURANTS' },
  { label: 'Healthcare', value: 'HEALTHCARE' },
  { label: 'Hospitality', value: 'HOSPITALITY' },
  { label: 'Insurance', value: 'INSURANCE' },
  { label: 'IT services', value: 'IT_SERVICES' },
  { label: 'Industry goods services', value: 'INDUSTRY_GOODS_SERVICES' },
  { label: 'Legal services', value: 'LEGAL_SERVICES' },
  { label: 'Medical service', value: 'MEDICAL_SERVICE' },
  { label: 'Money transfer', value: 'MONEY_TRANSFER' },
  { label: 'Machinery', value: 'MACHINERY' },
  { label: 'Manufacturing', value: 'MANUFACTURING' },
  { label: 'Media', value: 'MEDIA' },
  { label: 'Marketplace', value: 'MARKETPLACE' },
  { label: 'Nbfc', value: 'NBFC' },
  { label: 'Not for profit', value: 'NOT_FOR_PROFIT' },
  { label: 'Professional service', value: 'PROFESSIONAL_SERVICE' },
  { label: 'Reseller app and web', value: 'RESELLER_APP_AND_WEB' },
  { label: 'Reseller', value: 'RESELLER' },
  { label: 'Real estate', value: 'REAL_ESTATE' },
  { label: 'Recreation', value: 'RECREATION' },
  { label: 'Retail', value: 'RETAIL' },
  { label: 'Shipping', value: 'SHIPPING' },
  { label: 'Securities', value: 'SECURITIES' },
  { label: 'Sports and events', value: 'SPORTS_AND_EVENTS' },
  { label: 'Subscription business', value: 'SUBSCRIPTION_BUSINESS' },
  { label: 'Society donations', value: 'SOCIETY_DONATIONS' },
  { label: 'Society other services', value: 'SOCIETY_OTHER_SERVICES' },
  { label: 'Travel and tourism', value: 'TRAVEL_AND_TOURISM' },
  { label: 'Technology', value: 'TECHNOLOGY' },
  { label: 'Telecommunications', value: 'TELECOMMUNICATIONS' },
  { label: 'Transportation', value: 'TRANSPORTATION' },
  { label: 'Utility', value: 'UTILITY' }
];

const competitiorCurrently = [
  {
    label: 'Razorpay',
    value: 'RAZORPAY'
  },
  {
    label: 'PayU',
    value: 'PAYU'
  },
  {
    label: 'Cashfree',
    value: 'CASHFREE'
  },
  {
    label: 'Stripe',
    value: 'STRIPE'
  },
  {
    label: 'PayTm',
    value: 'PAYTM'
  },
  {
    label: 'Billdesk',
    value: 'BILLDESK'
  },
  {
    label: 'Atom',
    value: 'ATOM'
  },
  {
    label: 'CCAvenue',
    value: 'CCAVENUE'
  },
  {
    label: 'Juspay',
    value: 'JUSPAY'
  },
  {
    label: 'Instamojo',
    value: 'INSTAMOJO'
  },
  {
    label: 'Chargbee',
    value: 'CHARGEBEE'
  },
  // {
  //   label: 'Others',
  //   value: 'OTHERS'
  // },
  {
    label: 'NA',
    value: 'NA'
  }
];

const leadRegion = [
  {
    label: 'North',
    value: 'NORTH'
  },
  {
    label: 'South',
    value: 'SOUTH'
  },
  {
    label: 'East',
    value: 'EAST'
  },
  {
    label: 'West',
    value: 'WEST'
  },
  {
    label: 'Inside Sales',
    value: 'INSIDE_SALES'
  },
  {
    label: 'NA',
    value: 'NA'
  }
];

const payoutStatus = [
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Calculating',
    value: 'CALCULATING'
  },
  {
    label: 'Failed',
    value: 'FAILED'
  },
  {
    label: 'Rejected',
    value: 'REJECTED'
  },
  {
    label: 'Generated',
    value: 'GENERATED'
  },
  {
    label: 'Waiting For Approval',
    value: 'WAITING FOR APPROVAL'
  },
  {
    label: 'Accepted',
    value: 'ACCEPTED'
  },
  {
    label: 'Disputed',
    value: 'DISPUTED'
  },
  {
    label: 'Cancelled',
    value: 'CANCELLED'
  },
  {
    label: 'Processing',
    value: 'PROCESSING'
  },
  {
    label: 'Paid',
    value: 'PAID'
  }
];

const state = [
  {
    value: 'Andaman and Nicobar Islands',
    label: 'Andaman and Nicobar Islands'
  },
  {
    value: 'Andhra Pradesh',
    label: 'Andhra Pradesh'
  },
  {
    value: 'Arunachal Pradesh',
    label: 'Arunachal Pradesh'
  },
  {
    value: 'Assam',
    label: 'Assam'
  },
  {
    value: 'Bihar',
    label: 'Bihar'
  },
  {
    value: 'Chandigarh',
    label: 'Chandigarh'
  },
  {
    value: 'Chhattisgarh',
    label: 'Chhattisgarh'
  },
  {
    value: 'Dadra and Nagar Haveli',
    label: 'Dadra and Nagar Haveli'
  },
  {
    value: 'Daman and Diu',
    label: 'Daman and Diu'
  },
  {
    value: 'Delhi',
    label: 'Delhi'
  },
  {
    value: 'Goa',
    label: 'Goa'
  },
  {
    value: 'Gujarat',
    label: 'Gujarat'
  },
  {
    value: 'Haryana',
    label: 'Haryana'
  },
  {
    value: 'Himachal Pradesh',
    label: 'Himachal Pradesh'
  },
  {
    value: 'Jammu and Kashmir',
    label: 'Jammu and Kashmir'
  },
  {
    value: 'Jharkhand',
    label: 'Jharkhand'
  },
  {
    value: 'Karnataka',
    label: 'Karnataka'
  },
  {
    value: 'Kerala',
    label: 'Kerala'
  },
  {
    value: 'Ladakh',
    label: 'Ladakh'
  },
  {
    value: 'Lakshadweep',
    label: 'Lakshadweep'
  },
  {
    value: 'Madhya Pradesh',
    label: 'Madhya Pradesh'
  },
  {
    value: 'Maharashtra',
    label: 'Maharashtra'
  },
  {
    value: 'Manipur',
    label: 'Manipur'
  },
  {
    value: 'Meghalaya',
    label: 'Meghalaya'
  },
  {
    value: 'Mizoram',
    label: 'Mizoram'
  },
  {
    value: 'Nagaland',
    label: 'Nagaland'
  },
  {
    value: 'Odisha',
    label: 'Odisha'
  },
  {
    value: 'Puducherry',
    label: 'Puducherry'
  },
  {
    value: 'Punjab',
    label: 'Punjab'
  },
  {
    value: 'Rajasthan',
    label: 'Rajasthan'
  },
  {
    value: 'Sikkim',
    label: 'Sikkim'
  },
  {
    value: 'Tamil Nadu',
    label: 'Tamil Nadu'
  },
  {
    value: 'Telangana',
    label: 'Telangana'
  },
  {
    value: 'Tripura',
    label: 'Tripura'
  },
  {
    value: 'Uttar Pradesh',
    label: 'Uttar Pradesh'
  },
  {
    value: 'Uttarakhand',
    label: 'Uttarakhand'
  },
  {
    value: 'West Bengal',
    label: 'West Bengal'
  }
];

const customReportStatus = [
  {
    label: 'Success',
    value: 'SUCCESS'
  },
  {
    label: 'In-Progress',
    value: 'INPROGRESS'
  },
  {
    label: 'Requested',
    value: 'REQUESTED'
  },
  {
    label: 'Failed',
    value: 'FAILED'
  }
];

const customReportTransactionsStatus = [
  {
    label: 'Success',
    value: 'SUCCESS'
  },
  {
    label: 'Bounced',
    value: 'BOUNCED'
  },
  {
    label: 'Dropped',
    value: 'DROPPED'
  },
  {
    label: 'Failed',
    value: 'FAILED'
  }
];

const cummlativeReportStatus = [
  {
    label: 'Paid',
    value: 'PAID'
  },
  {
    label: 'Ongoing',
    value: 'PROCESSING'
  },
  {
    label: 'Invoice Pending',
    value: 'PARTNER_AWAITING/INVOICE_ON_HOLD'
  }
];

const PAYOUT_CYCLE = {
  MONTHLY: {
    label: 'Monthly'
  },
  WEEKLY: {
    label: 'Weekly'
  },
  DAILY: {
    label: 'Daily'
  }
};

export const INTERACT = 'INTERACT';
export const BASIC = 'BASIC';
export const MONTHLY = 'MONTHLY';
export const YEARLY = 'YEARLY';

export const YEARLY_PRICE = 16992;

export const MONTHLY_PRICE = 1416;

export {
  activationStatus,
  kycStatus,
  merchantStatus,
  leadPriority,
  leadStatus,
  payoutStatus,
  businessEntityType,
  productList,
  accountSegment,
  industry,
  competitiorCurrently,
  state,
  customReportStatus,
  leadRegion,
  customReportTransactionsStatus,
  cummlativeReportStatus,
  PAYOUT_CYCLE
};
